import type { DocumentReference } from "fhir/r5";

export interface DocumentCategory {
  code: string;
  label: string;
  docs: DocumentReference[];
  /** Documentos com docStatus=cancelled — histórico. */
  cancelledDocs?: DocumentReference[];
}

export const ECOMMERCE_DOCUMENT_CATEGORIES = [
  { code: "anvisa_import_authorization", label: "Autorização Anvisa" },
  { code: "medical_prescription", label: "Receita médica" },
  { code: "personal_document", label: "Documento pessoal" },
  { code: "proof_of_residence", label: "Comprovante de residência" },
] as const;

export type EcommerceDocumentCategoryCode =
  (typeof ECOMMERCE_DOCUMENT_CATEGORIES)[number]["code"];
